import { render, staticRenderFns } from "./FullCar.vue?vue&type=template&id=aba46504&"
import script from "./FullCar.vue?vue&type=script&lang=js&"
export * from "./FullCar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports